import React, { type ReactNode, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "../../utils/constants";
import useAuth from "../../hooks/useAuth";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";

interface ProtectedRouteProps {
  children: ReactNode;
  redirectPath?: string;
  requireOnboarding?: boolean;
}
const defaultRedirectPath = ROUTES.ROOT.LOG_IN;

function ProtectedRoute({
  children,
  redirectPath = defaultRedirectPath,
  requireOnboarding = false,
}: ProtectedRouteProps): ReactElement {
  const { isLoggedIn } = useAuth();
  const { isOnboarding } = useOnboardingSteps();

  if (!isLoggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  if (requireOnboarding && !isOnboarding) {
    return <Navigate to={ROUTES.ROOT.HOME} replace />;
  }

  return <>{children}</>;
}

export { ProtectedRoute };
